import React, { Component } from 'react';
import './styles.scss';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

class GETrainersLoader extends Component {
  render() {
    const {trainerScreen = false } = this.props;
    return (
      <div className = 'ge-trainer-loader'>
        <SkeletonTheme color="#848484" highlightColor="#373737">
          <div className = 'loader-module'>
            {!trainerScreen &&
            <><div className = 'back-button mob-wrapper'>
              <Skeleton width={'18%'} height={17} />
            </div>
            <div>
              <div className = 'mob-wrapper'>
                <Skeleton width={'90%'} height={74} />
              </div>
              <div className="mob-wrapper">
                <Skeleton height={50} width={'65%'} />
              </div>

            </div>
          
            <div className = 'mob-hide admin-button'>
              <Skeleton height={20} width={'47%'}/>
            </div>
            <div className = 'search-box-container'>
              <div className = 'people-count mob-hide'><Skeleton height={30} width={'100%'}/></div>
              <div className = 'add-admin mob-hide'><Skeleton height={17} width={'100%'}/></div>
              <div  className = 'search-box'><Skeleton className = 'elliptical' height={40} width={'100%'}/></div>
            </div> </>}

           
            <div className = 'row-container always-show row-header darkbackground '>
                <Skeleton className= 'row-item-profile' height={12} width={160}/>
                <Skeleton className= 'mobile-hide' height={12} width={96}/>
                <Skeleton className = 'tablet-hide' height={12} width={96}/>
                <Skeleton className = 'tablet-hide' height={12} width={96}/>
                
            </div>
            {Array(2).fill().map((item, index) => (
               <div  key ={item}>
                  <div className = 'row-container'>
                      <Skeleton className= 'row-item-profile' height={34} width={160}/>
                      <Skeleton height={23} width={96}/>
                      <Skeleton className = 'tablet-hide' height={23} width={96}/>
                      <Skeleton className = 'tablet-hide' height={23} width={96}/>
                     
                  </div>
                  <div className = 'row-container darkbackground'>
                      <Skeleton className= 'row-item-profile' height={34} width={160}/>
                      <Skeleton height={23} width={96}/>
                      <Skeleton className = 'tablet-hide' height={23} width={96}/>
                      <Skeleton className = 'tablet-hide' height={23} width={96}/>
                    
                  </div>
                </div>
                  ))}
            {Array(2).fill().map((item, index) => (
              <div key={item}>
                    <div className = 'mob-row-container'>
                      <Skeleton className = 'mob-row-profile' height={40} width={40}></Skeleton>
                      <Skeleton className = 'mob-row-data' height={40} width={100}></Skeleton>
                    </div>
                    <div className = 'mob-row-container darkbackground'>
                      <Skeleton className = 'mob-row-profile' height={40} width={40}></Skeleton>
                      <Skeleton className = 'mob-row-data' height={40} width={100}></Skeleton>
                    </div>
                  </div>
            ))}
            </div>
        </SkeletonTheme>
      </div>
    );
  }
}

export default GETrainersLoader;